import { resolveUrl } from "~/utils/url/urlResolver";
import * as ApiHelper from "~/common/utils/ApiHelper";

export async function requestCadNotification(productCode: string) {
  const url = resolveUrl(`/p/subscribe-cad-availability/${productCode}`);

  const response = await fetch(url, {
    method: "POST",
    headers: {
      CSRFToken: ApiHelper.getCsrfValue(),
    },
  });

  if (response.ok) {
    return;
  }
  throw new Error(response.status + "");
}
